export const DATADOG_SERVICE_NAME = "Mem Client";
export const DATADOG_SITE = "datadoghq.com";

export const DATADOG_RUM_APPLICATION_ID = "806a7737-a414-4abf-a18a-36fb56b8b577";
export const DATADOG_RUM_CLIENT_TOKEN = "pub3712ffba36a81594308cf7d14aecf91d";

export const DATADOG_LOGGING_CLIENT_TOKEN = `pubb199963144c474768326e600b7c7b290`;
